module.exports = require("./fr-DJ");